
import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { cn } from "@/lib/utils";

interface CertificateQRCodeProps {
  url: string;
  size?: number;
  className?: string;
}

export function CertificateQRCode({ url, size = 128, className }: CertificateQRCodeProps) {
  // Ensure the URL is absolute
  const absoluteUrl = url.startsWith('http') ? url : `${window.location.origin}${url.startsWith('/') ? '' : '/'}${url}`;

  return (
    <a
      href={absoluteUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "group relative block rounded-lg p-2 transition-all hover:bg-primary/5",
        className
      )}
      onClick={(e) => e.stopPropagation()}
      aria-label={`QR code link to certificate. Click to open in new tab.`}
    >
      <QRCodeSVG
        value={absoluteUrl}
        size={size}
        level="H"
        includeMargin
        className="rounded-lg transition-transform group-hover:scale-105"
        aria-hidden="true"
      />
      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
        <span className="bg-primary/90 text-primary-foreground px-3 py-1 rounded-full text-sm font-medium">
          Click to visit
        </span>
      </div>
    </a>
  );
}
